'use strict';
/**
 * @name masterExport Directive
 * @desc Directive for generating export CSV
 *
 * @isolatedScope moduleName
 * To accept the module name to be displayed with button
 *
 * @isolatedScope collection
 * To determine which module to generate CSV for
 *
 * @isolatedScope companyId
 * Exclusive for company exchange rate, to pass company id for exporting
 *
 * @isolatedScope companyCode
 * Exclusive for company exchange rate, to pass company code for exporting
 *
 * @isolatedScope checkingList
 * To determine whether the PR list exist for exporting
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @copyright Sunway Metacloud &copy; 2016
 */
angular
  .module('metabuyer')
  .directive('masterExport',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/masterExportCSV/masterExportCSV-template.html',
      scope: {
        moduleName: '@',
        collection: '@',
        companyId: '=?',
        companyCode: '=?',
        disableButton: '=?'
      },
      controller: function ($scope, $state, toastr, exports, checkExportStatus, $interval, pathConstants,
                            $filter, globalFunc, $stateParams, exportSearch) {

        $scope.generateExportCSV = generateExportCSV;
        /**
         * Function to download the export, this will be called automatically once generation is done
         * @param hash
         */
        function downloadExport(hash){
          var newUrl = $filter('format')(pathConstants.apiUrls.export.download, {
            export_hash: hash
          });
          window.open(newUrl, '_self');
        }

        /**
         * Function to check the export status with intervals
         * @param id
         */
        function checkExport(id){

          checkExportStatus.get(
            {
              id: id
            },
            function(resource){
              if(!!resource.content && !!resource.content.data &&
                !!resource.content.message && !!resource.content.data.status){

                /**
                 * Clearing the toastr before every call for status checking to simulate 'refreshing' the toastr
                 */
                toastr.clear();

                var checkingStatus = true;

                /**
                 * Status for export CSV
                 * 0 = PENDING
                 * 1 = IN_PROGRESS
                 * 2 = DONE
                 * 3 = FAILED
                 * 4 = CANCELLED
                 */
                switch(resource.content.data.status){
                  case 0:
                    toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
                    break;
                  case 1:
                    toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
                    break;
                  case 2:
                    /**
                     * If has is returned
                     */
                    if(!!resource.content.data.hash){
                      toastr.success(resource.content.message,
                        {timeOut: 0, extendedTimeOut: 0, onClose: downloadExport(resource.content.data.hash)});
                    }
                    /**
                     * Else condition to handle case if hash not returned by backend
                     */
                    else{
                      toastr.error('There was an error with the export. Please try again');
                    }
                    checkingStatus = false;
                    $interval.cancel($scope.startChecking);
                    break;
                  case 3:
                    checkingStatus = false;
                    toastr.error(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
                    $interval.cancel($scope.startChecking);
                    break;
                  case 4:
                    checkingStatus = false;
                    toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
                    $interval.cancel($scope.startChecking);
                    break;
                }

                $scope.checkingExportStatus = checkingStatus;
              }
            },
            function(error){
              globalFunc.objectErrorMessage(error);
            }
          )
        }

        /**
         * @function generateExportCSV
         * This function is to generate the export CSV with parameters
         *
         * @params collection
         * Values:
         *         0 for Currencies
         *         1 for Companies
         *         2 for CostCenters
         *         3 for AccountCodes
         *         4 for ExchangeRates
         *         5 for UOMs
         *         6 for PaymentTerms
         *         7 for PaymentMethods
         *         8 for Taxes
         *         9 for ExpenseTypes
         *         10 for Suppliers
         *         101 for Supplier Tags
         *         11 for Commodities
         *         12 for Users
         *         13 for Catalogs
         *         16 for Catalog Items
         *         17 for PR
         *         18 for PO
         *         19 for Industries
         *         20 for Business Units
         */
        function generateExportCSV(){
          $scope.checkingExportStatus = true;

          var params = {};
          /**
           * To check if there are params set before the export, in order to pass criteria
           */
          if(!!exportSearch.getParams()) {
            params = exportSearch.getParams();
          }
          else {
            params['criteria[company_id]'] = (($scope.collection === '4' || $scope.collection === '2') ? (!!$scope.companyId ?
              $scope.companyId : '') : null);
            params['criteria[company_code]'] = (($scope.collection === '2' || $scope.collection === '3') ?
              (!!$scope.companyCode ? $scope.companyCode : '') : null);
          }

          /**
           * Criteria[company_id] is passed only when exporting exchange rate
           * If exchange rate is company level, pass the id, else pass empty string to indicate tenant level
           */
          exports.post(
              params,
              {
                collection: $scope.collection
              },
              function (resource) {
                if(!!resource.content && !!resource.content.data && !!resource.content.message){

                  toastr.info('Data is being exported. The download will start automatically', {timeOut: 0, extendedTimeOut: 0});

                  /**
                   * Calling the function checkExport with interval of 5 seconds
                   * Set the promise to a scope in order to cancel the call once generation is complete
                   */
                    //TODO: Support multiple interval calling
                  $scope.startChecking = $interval(function () {
                    checkExport(resource.content.data._id)
                  }, 5000);
                }
              },
              function (error) {
                $scope.checkingExportStatus = false;
                toastr.error('Data failed to be exported');
              }
            )
        }
      }
    }
  });
